import { TDashboardSegment } from '@api/lendingAPI/dashboardSegmentResponse.types';

import { LAYOUTS } from './segments/layouts';
import { TAccountFeatureMap } from '../multiLoanDashboard/AccountFeatureEvaluator/AccountFeatureEvaluator';

export const SegmentedDashboard = ({
    segment,
    accountId,
    features
}: {
    segment: TDashboardSegment;
    accountId: string;
    features: TAccountFeatureMap;
}) => {
    const Layout = LAYOUTS[segment];

    if (!Layout) {
        return null;
    }

    return (
        <div data-testid="segmented-dashboard">
            {/* TODO(TRT-2401): remove once the layouts are visually distinct. */}
            <p className="bg-structure-100 px-l pt-l text-s">
                Segment: {segment}
            </p>
            <Layout accountId={accountId} features={features} />
        </div>
    );
};
